var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#EDF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7604 43.1313C56.2796 40.4783 55.378 37.086 52.7468 35.5543C50.1156 34.0227 46.7511 34.9316 45.2319 37.5846L33.8716 57.4236C32.3525 60.0765 33.254 63.4688 35.8852 65.0005C38.5165 66.5322 41.881 65.6232 43.4001 62.9703L54.7604 43.1313Z",
    fill: "#F8BB2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1307 60.1994C44.1307 63.2636 41.667 65.7476 38.6278 65.7476C35.5887 65.7476 33.125 63.2636 33.125 60.1994C33.125 57.1352 35.5887 54.6511 38.6278 54.6511C41.667 54.6511 44.1307 57.1352 44.1307 60.1994Z",
    fill: "#3BA757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2482 43.1313C43.7291 40.4783 44.6306 37.086 47.2618 35.5543C49.893 34.0227 53.2576 34.9316 54.7767 37.5846L66.137 57.4236C67.6562 60.0765 66.7546 63.4688 64.1234 65.0005C61.4922 66.5322 58.1276 65.6232 56.6085 62.9703L45.2482 43.1313Z",
    fill: "#4689F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventAds);
export default __webpack_public_path__ + "static/media/canvas_event_ads.32d13cbb6af0e98310822ed3e0f4e877.svg";
export { ForwardRef as ReactComponent };